import Vue from 'vue'
import Router from 'vue-router'
// import login from '@/components/login'

Vue.use(Router)

const router = new Router({
  // routes: [{
  //   path: '/',
  //   name: 'login',
  //   component: login
  // }]
  routes: [{
      path: '/',
      name: 'coupon',
      component: () => import("@/views/coupon"),
      meta: { title: '购物补贴金' }
    }, {
      path: '/couponlist',
      name: 'couponlist',
      component: () => import("@/views/couponlist"),
      meta: { title: '购物补贴金' }
    }, {
      path: '/invitePlan',
      name: 'invitePlan',
      component: () => import("@/views/invitePlan"),
      meta: { title: '推荐购物返佣福利' }
    }, {
      path: '/buypileh5',
      name: 'buypileh5',
      component: () => import("@/views/buypileh5"),
      meta: { title: '购桩邀请' }
    },{
      path: '/yunshanfuh5',
      name: 'yunshanfuh5',
      component: () => import("@/views/yunshanfuh5"),
      meta: { title: '云闪付1分钱充电' }
    },{
      path: '/chargemerchant',
      name: 'chargemerchant',
      component: () => import("@/views/chargemerchant"),
      meta: { title: '猛犸充电' }
    },{
      path: '/subscribe',
      name: 'subscribe',
      component: () => import("@/views/subscribe"),
      meta: { title: '猛犸充电' }
    },
    ,{
      path: '/openLaunchApp',
      name: 'openLaunchApp',
      component: () => import("@/views/openLaunchApp"),
      meta: { title: '跳转小程序' }
    }
  ]

})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
})
export default router